import React from 'react';

import TextsmsIcon from '@mui/icons-material/Textsms';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { ErrorBoundary } from '@suspensive/react';
import { useSetAtom } from 'jotai';
import Lottie from 'lottie-react';
import { useRecoilValue } from 'recoil';

import { aclosetChatState } from '@/app/chat/AclosetChatState';
import { aclosetChatStore } from '@/app/chat/acloset-chat-store';
import { acCaptureException } from '@/thirdparty/ASentry/Log';

import '../animation.css';
import lottie from './lottie.json';

export const AclosetChatNotification = React.memo(function AclosetChatNotification() {
  return (
    <ErrorBoundary
      fallback={<AclosetChatNotificationIcon />}
      onError={error => {
        acCaptureException('Failed to initialize.', error);
      }}
    >
      <AclosetChatNotificationImpl />
    </ErrorBoundary>
  );
});

const AclosetChatNotificationImpl = () => {
  const setChatStore = useSetAtom(aclosetChatStore);

  const aclosetChatValue = useRecoilValue(aclosetChatState);

  if (aclosetChatValue.totalUnreadChannelCount > 0) {
    return (
      <ChatLottie
        onClick={() => {
          setChatStore(prev => ({
            ...prev,
            open: true,
          }));
        }}
      />
    );
  } else {
    return (
      <AclosetChatNotificationIcon
        onClick={() => {
          setChatStore(prev => ({ ...prev, open: true }));
        }}
      />
    );
  }
};

/**
 * 세컨솔드 문의 알림 애니메이션
 * @see https://www.figma.com/file/nXdcRY9z6Mu16FiyYb7RFZ/%EC%97%90%ED%94%BD%EC%97%86%EB%8A%94%EC%9D%B4%EC%8A%88?type=design&node-id=1171-20148&mode=dev
 */
function ChatLottie({ onClick }: { onClick: () => void }) {
  return (
    <div style={{ position: 'relative', top: 3, cursor: 'pointer' }} onClick={onClick}>
      <Lottie animationData={lottie} loop={false} />
      <Typography
        className="lottie animated infinite"
        variant="Subtitle_Looko"
        color="error.light"
        position={'absolute'}
        style={{
          top: 8,
          left: 40,
        }}
      >
        세컨솔드 고객의 문의가 있습니다
      </Typography>
    </div>
  );
}

const AclosetChatNotificationIcon = ({ onClick }: { onClick?: () => void }) => {
  const hasError = onClick == null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '30px' }}>
      <Tooltip arrow title={hasError ? '세컨솔드 채팅 서비스에 연결할 수 없습니다.' : '세컨솔드 채팅'}>
        <span>
          <IconButton
            sx={{
              color: 'white',
              width: 32,
              height: 32,
            }}
            onClick={onClick}
            disabled={hasError}
          >
            <TextsmsIcon opacity={hasError ? 0.5 : 1} sx={{ color: 'black' }} fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};
